import Intercom from '@intercom/messenger-js-sdk';
import { useLocation } from 'react-router-dom';
import { useFlags } from 'launchdarkly-react-client-sdk';

import useIntercomTokenRefresh from '../hooks/useIntercomTokenRefresh';
import { useGlobalContext } from '~/lib/contexts/GlobalContext';
import { VITE_INTERCOM_APP_ID } from '~/lib/constants/env';
import { Path } from '~/routes/constants';
import { useGetIntercomMaudJWTQuery } from '~/store/services/integration';

const useHelpWidget = (): void => {
  const { currentUser } = useGlobalContext();
  const { userId } = currentUser;

  const { data, refetch } = useGetIntercomMaudJWTQuery();

  useIntercomTokenRefresh(
    data?.expiresAt ? `${Number(data.expiresAt)}` : undefined,
    refetch,
  );

  const { maudIntercomChatMvp: isMaudIntercomChatMvpEnabled } =
    useFlags<LDFlags>();
  const location = useLocation();

  Intercom({
    app_id: VITE_INTERCOM_APP_ID,
    hide_default_launcher:
      !isMaudIntercomChatMvpEnabled ||
      location.pathname !== Path.CALENDAR_SCHEDULE,
    intercom_user_jwt: data?.token,
    user_id: userId,
  });
};

export default useHelpWidget;
